import React, {useState, useEffect} from 'react';
import LandingPageNav from "../../components/navbars/landingPage";
import { trackEvent } from "../../services/analytics";
import {Image} from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import Section from "../../components/landingPage/sections";
import FooterLandingPage from "../../components/footers/landing";
import {Helmet} from "react-helmet";
import TextLoop from "react-text-loop";

const WooCommerce = (props) => {
    const [pricing, setPricing ] = useState('monthly');
    const { t, i18n } = useTranslation();
    const [ lang, setLang ] = useState('en');
    const [ loading, setLoading ] = useState(true);
    
    useEffect(()=> {
        const lang = props.match.params.lang || localStorage.getItem('language');
        setLang(lang);
        setLoading(false);
        i18n.changeLanguage(lang)
        localStorage.setItem('language', lang);
    },[]);


    const changePricing = (e) => {
      if (e === 'monthly') {
          setPricing('monthly')
      }  else {
          setPricing('yearly')
      }
    };
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Biteship: Plugin WooCommerce</title>
                <meta name="description" content="Plugin Ongkos Kirim WooCommerce terlengkap. Integrasikan website WooCommerce Anda dengan teknologi Biteship. Mulai dari Cek Ongkos Kirim hingga pembuatan resi hanya dengan menginstall Plugin Biteship." />
                <link rel="canonical" href="https://biteship.com/woocommerce" />
            </Helmet>
            <LandingPageNav/>
            <section className="slice">
                <div className="container-fluid">
                    <div style={{height:60}}/>
                    <div className="row row-grid align-items-center justify-content-around">
                        <div className="col-lg-5">
                            <div className="img-back-shape">
                                <img alt="Biteship WooCommerce" src="/images/landing/wp-header.png"
                                     className="img-center img-fluid"/>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="pr-md-4">
                                <h1 className=" lh-150">
                                    <strong>
                                        Plugin Service
                                    </strong>
                                </h1>
                                <p className="lead mb-5">Integrasikan toko online Anda dengan pilihan Plugin Biteship dan rasakan fitur pengiriman yang lengkap di Website Anda</p>
                                <div className="card mb-2">
                                    <div className="card-body py-4">
                                        <div className="d-flex align-items-start">
                                            <div
                                                className="icon bg-gradient-primary text-white rounded-circle icon-shape">
                                                <i className="fas fa-truck"></i>
                                            </div>
                                            <div className="icon-text pl-4">
                                                <h5 className="ma-0 ">Cek Ongkos Kirim</h5>
                                                <p className="mb-0">Plugin ongkos kirim untuk website Anda. Kurir lengkap mulai dari kurir instan sampai kurir kargo.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-body py-4">
                                        <div className="d-flex align-items-start">
                                            <div
                                                className="icon bg-pink text-white rounded-circle icon-shape">
                                                <i className="fas fa-receipt"></i>
                                            </div>
                                            <div className="icon-text pl-4">
                                                <h5 className="ma-0 ">Pembuatan Resi</h5>
                                                <p className="mb-0">Langsung mengeluarkan resi dan request penjemputan untuk memudahkan operasional sehari-hari.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="slice bg-lighter">
                <div className="container">
                    <h2 className=" lh-150 text-center">
                        <strong>
                            Pilihan Kurir di Checkout Page
                        </strong>
                    </h2>
                    <h4 className="text-center text-swift-pink">Mulai dari pengiriman instant sampai pengiriman kargo dapat dipasang di website Anda</h4>
                    <Image
                        className="img-center"
                        id="img-woo-checkout"
                        alt="biteship-woo-checkout"
                        src="/images/landing/biteship-woo-checkout.png"
                    />
                </div>
            </section>

            <section className="slice bg-lighter ">
                <div className='container'>
                    <h2>
                        <strong>
                            Tingkatkan fitur pengiriman pada website Anda                        
                        </strong>
                        <p className='lead mt-2'>
                            Pengguna Website seperti Shopify dan WooCommerce seller senang memudahkan operasional mereka dengan layanan Biteship.                        
                        </p>
                    </h2>
                    <div className='mt-4'>
                        <h2 className='text-tiffany-500 mt-2'>
                            <strong>
                                Integrasi plugin lainnya                                
                            </strong>
                        </h2>
                        <p className='lead mt-2'>
                            Sediakan berbagai macam pengiriman pada website e-commerce platform Anda.                            
                        </p>
                        <div className='row align-items-center'>
                            <div className='col-3 px-4'>
                                <img alt="Biteship WooCommerce Plugin" src="/images/landing/biteship-woo.png" className="img-fluid"/>
                            </div>
                            <div className='col-3 px-5'>
                                <img alt="Biteship Shopify Plugin" src="/images/landing/biteship-shopify.png" className="img-fluid"/>
                            </div>
                            <div className='col-3 px-5'>
                                <img alt="Biteship Magento Plugin" src="/images/landing/biteship-magento.png" className="img-fluid"/>
                            </div>
                            <div className='col-3 px-4'>
                                <img alt="Biteship Prestashop Plugin" src="/images/landing/biteship-prestashop.png" className="img-fluid"/>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <section className="slice">
                <div className="container">
                    <div className="mb-5 text-center">
                        <h2 className=" lh-150 text-center">
                            <strong>
                                Harga Layanan
                            </strong>
                        </h2>
                    </div>
                    <div className="pricing-container">
                        <div className="text-center mb-6">
                            <div className="btn-group" role="group">
                                <button onClick={() => changePricing('monthly')}
                                        type="button"
                                        className={`btn btn-secondary ${pricing === 'monthly' ? 'active' :''}`}
                                        data-pricing="monthly"
                                >
                                    Monthly billing
                                </button>
                                <button onClick={() => changePricing('yearly')}
                                        type="button"
                                        className={`btn btn-secondary ${pricing === 'monthly' ? '' :'active'}`}
                                        data-pricing="yearly"
                                >
                                    Yearly billing
                                </button>
                            </div>
                        </div>
                        <div className="pricing card-group flex-column flex-lg-row mb-3">
                            <div className="card card-pricing text-center px-3 mb-5 mb-lg-0 pt-0 shadow">
                                <span
                                className="h6 w-60 mx-auto px-4 py-1 rounded-bottom bg-primary text-white">Starter</span>
                                <div className="card-header py-5 border-0">
                                    <div className="h2 text-primary text-center mb-0" data-pricing-value="12"><span
                                        className="price">Free</span>
                                        <span className="h6 ml-2"><br/>{pricing === 'monthly' ? ' / month' : ' / year' }</span></div>
                                </div>
                                <div className="card-body delimiter-top">
                                    <ul className="list-unstyled mb-4">
                                        <li>Kurir Layanan Standard</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="card card-pricing text-center px-3 mb-5 mb-lg-0 pt-0 shadow">
                                <span
                                className="h6 w-60 mx-auto px-4 py-1 rounded-bottom bg-primary text-white">Essentials</span>
                                <div className="card-header py-5 border-0">
                                    <div className="h2 text-primary text-center mb-0" data-pricing-value="24">Rp <span
                                        className="price">{pricing === 'monthly' ? '49.000' : '549.000' }</span>
                                        <span className="h6 ml-2"><br/>{pricing === 'monthly' ? ' / month' : ' / year' }</span></div>
                                </div>
                                <div className="card-body delimiter-top">
                                    <ul className="list-unstyled mb-4">
                                        <li><strong>+ Free</strong></li>
                                        <li>Kurir Layanan Next Day</li>

                                    </ul>
                                    { pricing === 'yearly' ?
                                        <span className="badge badge-soft-success badge-pill badge-lg badge-success">
                                        Hemat 1 Bulan
                                    </span> : null
                                    }
                                </div>
                            </div>
                            <div className="card card-pricing popular scale-110 text-center px-3 mb-5 mb-lg-0 pt-0">
                            <span
                                className="h6 w-60 mx-auto px-4 py-1 rounded-bottom bg-primary text-white">Standard</span>
                                <div className="card-header py-5 border-0">
                                    <div className="h2 text-primary text-center mb-0" data-pricing-value="36">Rp <span
                                        className="price">{pricing === 'monthly' ? '79.000' : '790.000' }</span>
                                        <span className="h6 ml-2"><br/>{pricing === 'monthly' ? ' / month' : ' / year' }</span></div>
                                </div>
                                <div className="card-body delimiter-top">
                                    <ul className="list-unstyled mb-4">
                                        <li><strong>+ Essentials</strong></li>
                                        <li>Kurir Instan</li>
                                    </ul>
                                    { pricing === 'yearly' ?
                                        <span className="badge badge-soft-success badge-pill badge-lg badge-success">
                                        Hemat 2 Bulan
                                        </span> : null
                                    }
                                </div>
                            </div>
                            <div className="card card-pricing text-center px-3 mb-5 mb-lg-0 pt-0 shadow">
                            <span
                                className="h6 w-60 mx-auto px-4 py-1 rounded-bottom bg-primary text-white">Premium</span>
                                <div className="card-header py-5 border-0">
                                    <div className="h2 text-primary text-center mb-0" data-pricing-value="48">Rp <span
                                        className="price">{pricing === 'monthly' ? '99.000' : '890.000' }</span>
                                        <span className="h6 ml-2"><br/>{pricing === 'monthly' ? ' / month' : ' / year' }</span></div>
                                </div>
                                <div className="card-body delimiter-top">
                                    <ul className="list-unstyled mb-4">
                                        <li><strong>+ Standard</strong></li>
                                        <li>Kurir Same Day</li>
                                        <li>Kurir Kargo</li>
                                    </ul>
                                    { pricing === 'yearly' ?
                                        <span className="badge badge-soft-success badge-pill badge-lg badge-success">
                                            Hemat 3 Bulan
                                        </span> : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{height:100}}/>
                <a href="https://wordpress.org/plugins/biteship"
                   onClick={() => trackEvent("Link To Biteship Plugin Clicked",{
                       action: "track",
                       category: "Links",
                       label: 'Download Biteship WP Plugin',
                       event: "Click"
                   })}>
                    <button className="btn btn-lg btn-outline-primary center">Download Plugin Biteship Disini</button>
                </a>
            </section>

            <section className="slice slice-lg">
                <br/>
                <div className="mt-4 mb-4">
                    <div className="text-center">
                        <h2 className=" lh-150">
                            <strong>
                                Cek ongkos kirim berbagai macam kurir di Indonesia.
                            </strong>
                        </h2>
                        <h4 className="text-center text-swift-pink">
                            Tingkatkan experience belanja melalui website Anda!
                        </h4>
                    </div>
                </div>
                <div className="container mt-4">
                    <div className="hover-blurable">
                        <a href="#">
                            <div className="blurable-item client-group row justify-content-center">
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship jne" src="images/landing/jne.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship wahana" src="images/landing/wahana.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship gosend" src="images/landing/gosend.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship paxel" src="images/landing/paxel.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship sicepat" src="images/landing/sicepat.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship jnt" src="images/landing/jnt.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship tiki" src="images/landing/tiki.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship deliveree" src="images/landing/deliveree.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship fedex" src="images/landing/fedex.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship anteraja" src="images/landing/anteraja.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship grab" src="images/landing/grab.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship rpx" src="images/landing/rpx.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship jet" src="images/landing/jet.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship lion" src="images/landing/lion.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship sap" src="images/landing/sap.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship qrim" src="images/landing/qrim.png"/>
                                </div>
                                <div className="client col-lg-2 col-md-3 col-4 py-3">
                                    <img alt="Biteship pos" src="images/landing/pos.png"/>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div style={{height:320}}/>
            </section>


            <Section/>
            <FooterLandingPage/>

        </>
    );
};

export default WooCommerce;
